import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import cookie from "react-cookies";
import { clearMediaAccessCookie } from "../../../utils/mediaAccessCookie";

class Logout extends Component {
  componentDidMount() {
    // Clear all cookies
    cookie.remove("session-id-qt", { path: "/" });
    cookie.remove("ctName", { path: "/" });
    cookie.remove("localsessionid", { path: "/" });
    cookie.remove("promocode", { path: "/" });
    clearMediaAccessCookie();
    
    // Clear localStorage items
    localStorage.clear();
  }

  render() {
    return <Redirect to="/" />;
  }
}

export default Logout; 